import styled from '@emotion/styled';
import React from 'react';
// ---- external imports ----

import confirmBtnProjection from '~/assets/images/baseAssets/confirmModal/hire.png';
import cancelBtnProjection from '~/assets/images/baseAssets/confirmModal/cancel.png';
import { withProjection } from '~/hoc';
// ---- internal imports ----

import Asset from './BaseAssets';
import PopupModalBase from './PopupModalBase';
// ---- local imports ----


function ConfirmationModal(props) {
	if (!props.isOpen) {
		return null;
	}

	const scale = props.scale || 1;
	const fontSize = (props.fontSize || 19) * scale;

	return (
		<PopupModalBase
			title={props.title}
			scale={scale}
			data-testid={`${props['data-testid-prefix']}`}
		>
			<ConfirmText
				x={450 * scale}
				y={313 * scale}
				projection={{
					width: 474 * scale,
					height: 144 * scale
				}}

				fontSize={fontSize}
				data-testid={`${props['data-testid-prefix']}-text`}
			>
				<div>
					{props.children}
				</div>
			</ConfirmText>
			<ConfirmButton
				x={718 * scale}
				y={493 * scale}
				scale={scale}
				onClick={props.onConfirm}
				data-testid={`${props['data-testid-prefix']}-confirm-btn`}
			/>
			<CancelButton
				x={518 * scale}
				y={493 * scale}
				scale={scale}
				onClick={props.onCancel}
				data-testid={`${props['data-testid-prefix']}-cancel-btn`}
			/>
		</PopupModalBase>
	);
}

const ConfirmText = styled(Asset.Text)`
	display: flex;
	place-items: center;
	line-height: 1.6;
	font-family: Wonderfull;
	color: #fdeea9;
`;

const ConfirmButton = withProjection(Asset.Button, confirmBtnProjection);

const CancelButton = withProjection(Asset.Button, cancelBtnProjection);


export default ConfirmationModal;
